import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function RichText({ text, className = "" }) {
  return (
    <div className={`whw-rich ${className}`} data-testid="rich-text">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ node, ...p }) => <h1 className="font-heading text-2xl mt-5 mb-2 first:mt-0" {...p} />,
          h2: ({ node, ...p }) => <h2 className="font-heading text-xl mt-4 mb-2 first:mt-0" {...p} />,
          h3: ({ node, ...p }) => <h3 className="font-heading text-lg mt-3 mb-1.5 first:mt-0" {...p} />,
          p: ({ node, ...p }) => <p className="mb-3 leading-relaxed last:mb-0" {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-5 mb-3 space-y-1" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-5 mb-3 space-y-1" {...p} />,
          li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
          strong: ({ node, ...p }) => <strong className="font-semibold text-foreground" {...p} />,
          em: ({ node, ...p }) => <em className="italic" {...p} />,
          a: ({ node, ...p }) => <a className="text-secondary underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
          hr: () => <hr className="my-4 border-border" />,
          code: ({ node, inline, ...p }) => inline
            ? <code className="px-1.5 py-0.5 rounded bg-muted text-[0.9em]" {...p} />
            : <code className="block p-3 rounded-xl bg-muted text-sm overflow-x-auto my-3" {...p} />,
          blockquote: ({ node, ...p }) => (
            <blockquote
              data-testid="quote-block"
              className="my-4 rounded-2xl border-l-4 border-primary/60 bg-primary/5 px-4 py-3 font-heading text-[15px] leading-relaxed text-foreground/90 [&_p]:mb-1 [&_p:last-child]:mb-0 [&_p:last-child]:text-sm [&_p:last-child]:font-sans [&_p:last-child]:not-italic [&_p:last-child]:text-secondary"
              {...p}
            />
          ),
        }}
      >
        {text || ""}
      </ReactMarkdown>
    </div>
  );
}
